import { render, staticRenderFns } from "./PaapHistoryModal.vue?vue&type=template&id=b3798e02"
import script from "./PaapHistoryModal.vue?vue&type=script&lang=js"
export * from "./PaapHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports